import * as actions from '../utils/Constants';

export const dismissAlert = (id) => {
    return {
        type: actions.DISMISS_ALERT,
        payload: id
    }
}